const consts = {
  vkApiVersion: '5.126',
  defaultVideoMimeType: 'video/mp4',
  defaultVideoFilename: 'video.mp4',
}

export default consts
